module.exports = __webpack_public_path__ + "static/media/accident.a8b26af7.svg";